const typeIcons = {
  bug:require("./icons/bug.svg").default,
  dark:require("./icons/dark.svg").default,
  dragon:require("./icons/dragon.svg").default,
  electric:require("./icons/electric.svg").default,
  fairy:require("./icons/fairy.svg").default,
  fighting:require("./icons/fighting.svg").default,
  fire:require("./icons/fire.svg").default,
  flying:require("./icons/flying.svg").default,
  ghost:require("./icons/ghost.svg").default,
  grass:require("./icons/grass.svg").default,
  ground:require("./icons/ground.svg").default,
  ice:require("./icons/ice.svg").default,
  normal:require("./icons/normal.svg").default,
  poison:require("./icons/poison.svg").default,
  psychic:require("./icons/psychic.svg").default,
  rock:require("./icons/rock.svg").default,
  steel:require("./icons/steel.svg").default,
  water:require("./icons/water.svg").default,
}

export default typeIcons;